module.exports = __webpack_public_path__ + "static/img/i-a-o-right1.76db628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i-a-o-right1.jpg
// module id = IMjN
// module chunks = 5